export default function About() {
  const features = [
    {
      icon: 'ri-global-line',
      title: 'Market Access',
      description: 'We open doors to new markets and territories, helping technology vendors expand their global footprint with strategic market entry solutions.',
      gradient: 'from-teal-500 to-emerald-500'
    },
    {
      icon: 'ri-team-line',
      title: 'Vendor Support',
      description: 'Comprehensive support services including partner enablement, technical assistance, and ongoing relationship management for sustained success.',
      gradient: 'from-emerald-500 to-green-500'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Growth Strategy',
      description: 'Data-driven growth strategies tailored to your technology solutions, ensuring maximum market penetration and revenue optimization.',
      gradient: 'from-green-500 to-teal-500'
    }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-sm font-semibold bg-gradient-to-r from-teal-600 to-emerald-600 bg-clip-text text-transparent uppercase tracking-wider">
              WHO WE ARE
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Your Strategic Partner in<br />Technology Market Expansion
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We specialize in connecting innovative technology vendors with emerging markets worldwide. Our expertise in market analysis, strategic partnerships, and comprehensive marketing solutions ensures your technology reaches the right audience at the right time.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white to-gray-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${feature.gradient} flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
